module.exports = __webpack_public_path__ + "img/rawbt.e15bc459.jpg";